import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import OrderPaymentDetailIndexPage from '../containers/OrderPaymentDetails'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const OrderPaymentDetailsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'order_payment_details') {
			dispatch(changeCurrent(['order_payment_details']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={OrderPaymentDetailIndexPage} exact />
		</Switch>
  )
}

OrderPaymentDetailsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

OrderPaymentDetailsPage.defaultProps = {}

export default OrderPaymentDetailsPage
